export default __webpack_public_path__ + "static/media/Hair_2_M_C2.92544b6d.svg";